import { NavLink } from 'react-router';
import { NavbarLanguageSwitcher } from '~/components/ui/navbar-language-switcher';
import type { ReactNode } from 'react';

type AuthPageLayoutProps = {
  children: ReactNode;
  /** Optional illustration rendered in the right teal panel */
  illustration?: ReactNode;
};

/**
 * Full-page split layout for auth screens (login, sign up, verify).
 * Left: white panel with logo, language switcher, and form content.
 * Right: teal illustration panel.
 */
export function AuthPageLayout({ children, illustration }: AuthPageLayoutProps) {
  return (
    <div
      className="
        flex min-h-screen
        md:h-screen md:overflow-hidden
      "
    >
      {/* Left: form panel */}
      <div
        className="
          flex min-h-screen w-full shrink-0 flex-col gap-xl overflow-y-auto
          bg-background-0 p-xl
          md:h-screen md:w-[520px]
        "
      >
        <div className="flex items-center justify-between">
          <NavLink to="/">
            <img alt="Startable logo" src="/favicon/favicon.svg" className="size-10" />
            <span className="sr-only">Startable</span>
          </NavLink>
          <NavbarLanguageSwitcher />
        </div>
        <div
          className="
            flex flex-1 flex-col justify-start gap-xl
            md:justify-center
          "
        >
          {children}
        </div>
      </div>

      {/* Right: illustration panel */}
      <div
        className="
          relative hidden flex-1 overflow-hidden bg-background-100
          md:block
        "
      >
        {illustration ?? (
          <img
            src="/assets/auth/signup.svg"
            alt=""
            className="size-full object-cover object-bottom"
          />
        )}
      </div>
    </div>
  );
}
